<form #form="ngForm" class="row mb-3" autocomplete="off" (ngSubmit)="ngSubmit()">
  <div class="col-12">
    <div class="input-group-icon">
      <input
        type="text"
        class="form-control"
        placeholder="Search for Residents"
        id="keyword"
        name="keyword"
        #keyword="ngModel"
        [(ngModel)]="model.keyword"
        required
        minlength="3"
        [ngClass]="{
          'is-invalid': submitted && keyword.invalid,
        }"
      />
      <button type="submit">
        <i class="bx bx-search text-primary"> </i>
      </button>
    </div>
  </div>
</form>

<div class="row">
  <div class="col-12">
    <ng-container *ngFor="let item of collection$ | async">
      <ng-container *ngIf="item.id !== user?.id">
        <div class="card shadow-none border">
          <div class="card-body">
            <div class="row g-2 align-items-center justify-content-end">
              <div class="col-auto">
                <div [style.width]="'60px'">
                  <div class="border border-secondary rounded-circle border-2 gallery-image">
                    <img
                      [src]="
                        item.profile.media
                          ? item.profile.media.url
                          : 'https://dummyimage.com/300/ebebeb/bdbdbd.jpg?text=Unavailable'
                      "
                      (error)="onImageError($event)"
                      class="img-fluid rounded-circle"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
              <div class="col">
                <h5 class="fw-bolder m-0">{{ item.firstName }} {{ item.lastName }}</h5>
              </div>
              <div class="col-auto">
                <button
                  (click)="emitter.emit(item)"
                  type="button"
                  class="btn btn-sm btn-soft-primary"
                >
                  Start a Conversation
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="col-12">
    <nav class="d-flex justify-content-center" aria-label="page-navigation">
      <ul class="pagination" *ngIf="meta && meta.total && meta.total > meta.limit!">
        <li class="page-item" [class.disabled]="meta.page === 1">
          <button class="page-link" (click)="goToPage(meta.page! - 1)">Previous</button>
        </li>

        <li
          class="page-item"
          *ngFor="let page of pages"
          [class.active]="meta.page === page"
          [class.disabled]="page === -1"
        >
          <button class="page-link" *ngIf="page !== -1" (click)="goToPage(page)">{{ page }}</button>
          <span class="page-link" *ngIf="page === -1">...</span>
        </li>

        <li class="page-item" [class.disabled]="meta.page === pages[pages.length - 1]">
          <button class="page-link" (click)="goToPage(meta.page! + 1)">Next</button>
        </li>
      </ul>
    </nav>
  </div>
</div>
